module.exports = __webpack_public_path__ + "static/img/bgt.46f2aea2.png";